import type { Brand } from '@seek/melways-sites';
import { useEffect, useState } from 'react';

import type { ApplyContext, Environment } from '../../../../../types';
import getJobDetails from '../../../../../utils/seekanz/getJobDetails';

export default (
  environment: Environment,
  nudge: string,
  locale: string,
  brand?: Brand,
) => {
  const [applyContext, setApplyContext] = useState<ApplyContext | null>(null);

  useEffect(() => {
    if (typeof nudge === 'string') {
      const [type, id] = nudge.split(':');
      if (type === 'apply') {
        getJobDetails(environment, id, locale, brand).then(setApplyContext);
      }
    }
  }, [environment, nudge, locale, brand]);

  return applyContext;
};
